<template>
    <div class="flex flex-wrap justify-center items-center gap-6 mb-12">
        <div
            v-for="method in methods"
            :key="method.id || method.code || method.name"
            class="bg-gray-50 rounded-[12px] border border-gray-200 p-6 flex items-center justify-center shadow-custom hover:shadow-custom-hover transition-all min-w-[140px]"
        >
            <img
                v-if="methodLogo(method)"
                :src="methodLogo(method)"
                :alt="methodLabel(method)"
                class="h-12 w-20 object-contain"
            />
            <span v-else class="text-gray-600 font-medium text-sm">{{ methodLabel(method) }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

defineOptions({ name: 'PaymentMethodsGrid' });

const store = useStore();

const methods = computed(() => {
    const raw = store.getters['form/paymentMethods'] || [];
    return raw.slice().sort((a, b) => {
        const na = (a.translated?.name || a.name || a.code || '').toString().toLowerCase();
        const nb = (b.translated?.name || b.name || b.code || '').toString().toLowerCase();
        return na.localeCompare(nb);
    });
});

function methodLabel(method) {
    return method?.translated?.name ?? method?.name ?? method?.code ?? '';
}

function methodLogo(method) {
    if (!method) return '';
    const img = method.image ?? method.logo ?? method.thumbnail;
    if (typeof img === 'string') return img;
    return img?.src ?? img?.url ?? '';
}

onMounted(async () => {
    if (methods.value.length) return;
    try {
        await store.dispatch('form/loadPaymentMethodsForDisplay');
    } catch (e) {
        console.warn('PaymentMethodsGrid: could not load payment methods', e);
    }
});
</script>
